// static app data used by a couple of dashboard pages
export const seedIEP = {
  goals: [
    { label: "Communicate needs using 3-4 word phrases", done: true },
    { label: "Participate in group activities with peers", done: true },
    { label: "Complete transitions with 1 verbal prompt", done: false },
  ],
  updates: [
    { date: "Apr 21", text: "Teacher log: Positive peer interaction during group time." },
    { date: "Apr 18", text: "Met communication goal in small group setting." },
    { date: "Apr 16", text: "Upcoming IEP meeting confirmed with school team." },
  ],
};
